/** @format */

import React from 'react'

const SelfAppraisal = () => {
  return <div>SelfAppraisal</div>
}

export default SelfAppraisal
